import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logOutToken } from '../actions/app_token'
import { createNewPlan, updatePlan, getPlans, loadPlan, openPlanPage, deletePlan,
  deletePlanFailure, getPlansFailure, updatePlanFailure, createNewPlanFailure } from '../actions/plan'
import { Sidebar, Segment, Button, Menu, Icon, Modal, Dropdown } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import '../App.css';
import 'semantic-ui-css/semantic.min.css';
import history from '../history'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import PlansListModal from '../components/custom_modal'
import { LOGIN_PATH, SYSTEM_TITLE, DASHBOARD_PATH } from '../constants'
import ConfirmToastr from '../components/confirm_toastr';
const ReactMarkdown = require('react-markdown')

class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      plans: [],
      templates: [],
      sidebarShown: false,
      pendingMessage: "",
      activeItem: 'risk_plans',
      notifications: "",
      messageShown: false,
      messageTimer: null,
      rowId: null,
      planName: null
    }

    this.plansColumns = [
      {
        dataField: 'name',
        text: 'Name',
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true
      },
      {
        dataField: 'updated_at',
        text: 'Last Modified',
        formatter: this.cellFormatter,
        headerStyle: {
          width: '300px'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.plansButtonsFormatter(cell, row, this),
        headerStyle: {
          width: '300px'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ]

    this.templatesColumns = [
      {
        dataField: 'name',
        text: 'Name',
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true
      },
      {
        dataField: 'updated_at',
        text: 'Last Modified',
        formatter: this.cellFormatter,
        headerStyle: {
          width: '300px'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.templatesButtonsFormatter(cell, row, this),
        headerStyle: {
          width: '300px'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ]

  }

  componentWillMount(){
    if (!this.props.signedIn){
      return history.push(LOGIN_PATH)
    }
  }

  componentDidMount(){
    this.props.getPlans();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.getPlansPending){
      this.setState({
        notifications: "  (Fetching...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.getPlansSuccess){
      if (nextProps.isTemplate){
        this.setState({
          templates: nextProps.plans,
          notifications: ""
        })
      }
      else {
        this.setState({
          plans: nextProps.plans,
          notifications: ""
        })
      }
      this.showNotifications(true);
      this.props.resetGetPlans();
    }

    if (nextProps.updatePending){
      this.setState({
        notifications: "  (Updating...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.updateSuccess){
      this.setState({
        notifications: "  (Changes to '"+ nextProps.plan.name +"' has been saved.)"
      });
      this.showNotifications(true);
      this.props.resetUpdate();
    }

    if (nextProps.deletePending){
      this.setState({
        notifications: "  (Deleting...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.deleteSuccess){
      this.setState({
        notifications: nextProps.plan.name + " has been deleted."
      })
      this.showNotifications(true);
      this.props.resetDelete();
      if (nextProps.isTemplate){
        this.props.getTemplates();
      }
      else{
        this.props.getPlans();
      }
    }

    this.loadingMessage(nextProps.createPending);
    if (nextProps.createSuccess){
      this.props.resetCreate();
    }

  };

  showNotifications(timed){
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, 3000);
    }
  }

  loadingMessage(pending){
    var messageblock = document.getElementById("create-notification");
    if (pending){
      messageblock.style.display = "inline";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  cellFormatter(cell, row) {
    return (
     <div className='cell-style'>
      { cell }
     </div>
    );
  }

  plansButtonsFormatter(cell, row, object) {
    return (
     <div className='cell-style'>
      <Button color='teal' fluid size='medium' onClick={() => object.props.openPlanPage(row.id)} className="open-plan-button"><i className="file alternate icon"></i>Open</Button>
      <Button color='red' fluid size='medium' onClick={() => object.showMessage(row)} className="delete-plan-button"><i className="delete icon"></i>Delete</Button>
     </div>
    );
  }

  templatesButtonsFormatter(cell, row, object) {
    return (
     <div className='cell-style'>
      <Button color='teal' fluid size='medium' onClick={() => object.props.newPlan(row.id)} className="open-plan-button"><i className="file alternate icon"></i>Create Plan</Button>
      <Button color='red' fluid size='medium' onClick={() => object.showMessage(row)} className="delete-plan-button"><i className="delete icon"></i>Delete</Button>
     </div>
    );
  }

  confirmDelete(){
    var message = "Are you sure to delete '"+ this.state.planName +"'?"
    if (this.state.messageShown ) {
      return <ConfirmToastr messageBody={message} messageType="blue" messageYes={()=>this.props.deletePlan(this.state.rowId)} dismiss={ this.dismissMessage.bind(this) }/>
    }
    return null;
  }

  showMessage(row) {
    this.setState({
      messageShown: true,
      rowId: row.id,
      planName: row.name
    })
  }

  dismissMessage() {
    this.setState({
      messageShown: false
    })
  }

  handleItemClick(e, object, name ){
    object.setState({
      activeItem: name
    });
    var risk_plans_el = document.getElementById('risk-plans');
    var risk_templates_el = document.getElementById('risk-templates');
    if (name === 'risk_plans'){
      this.props.getPlans();
      risk_plans_el.style.display = "block";
      risk_templates_el.style.display = "none";
    }
    else {
      this.props.getTemplates();
      risk_plans_el.style.display = "none";
      risk_templates_el.style.display = "block";
    }
  }

  toggleSideBar() {
    this.setState({ sidebarShown: true })
  }

  hideSideBar() {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  updatePlan(oldValue, newValue, row, column){
    if (oldValue !== newValue){
      this.props.updatePlan(row)
    }
  }

  render(props) {
    const { sidebarShown, plan, activeItem, plans, templates } = this.state
    return (
      <div className="App">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item name='home' as={Link} to={DASHBOARD_PATH}>
              <Icon name='home'></Icon>
              Dashboard
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <i className="bars icon" onClick={() => this.toggleSideBar()}></i>
              <header className="App-header">
                <h1 className="App-title">{SYSTEM_TITLE} - Files <span id="notifications">{this.state.notifications}</span></h1>
                <div id="create-notification">
                  <i className="loading circle notched icon plan-loading"></i>
                  <span>{this.props.pendingMessage}</span>
                </div>
              </header>
              <Button color='red' fluid size='medium' onClick={() => this.props.logout(this.props.token)} className="log-out-button">Logout</Button>
              <Menu>
                <Menu.Item
                  name='risk_plans'
                  active={activeItem === 'risk_plans'}
                  onClick={(evt)=>this.handleItemClick(evt, this, 'risk_plans')}
                >
                  Risk Plans
                </Menu.Item>

                <Menu.Item
                  name='risk_templates'
                  active={activeItem === 'risk_templates'}
                  onClick={(evt)=>this.handleItemClick(evt, this, 'risk_templates')}
                >
                  Risk Templates
                </Menu.Item>
              </Menu>
              { this.confirmDelete() }
              <div className="risks-table" id="risk-plans">
                <BootstrapTable
                  tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                  keyField="id"
                  data={ plans }
                  columns={ this.plansColumns }
                  cellEdit={ cellEditFactory({
                      mode: 'click',
                      blurToSave: true,
                      afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) }
                    })
                  }
                  striped
                  hover
                  condensed
                  noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>Please create new plan or load an existing plan.</span>}
                />
              </div>

              <div className="risks-table" id="risk-templates">
                <BootstrapTable
                  tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                  keyField="id"
                  data={ templates }
                  columns={ this.templatesColumns }
                  cellEdit={ cellEditFactory({ mode: 'click',blurToSave: true, afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) } }) }
                  striped
                  hover
                  condensed
                  noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>Please create new plan or load an existing plan.</span>}
                />
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    plan: state.plan.plan,
    plans: state.plan.plans,
    pendingMessage: state.plan.pendingMessage,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    deleteSuccess: state.plan.deleteSuccess,
    deletePending: state.plan.deletePending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    createSuccess: state.plan.createSuccess,
    createPending: state.plan.createPending,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    newPlan: (template_plan_id) => {
      dispatch(createNewPlan(template_plan_id))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    loadPlan: (plan_id) => {
      dispatch(loadPlan(plan_id))
    },
    getPlans: () => {
      dispatch(getPlans(null))
    },
    getTemplates: () => {
      dispatch(getPlans(true));
    },
    openPlanPage: (plan_id) => {
      openPlanPage(plan_id);
    },
    deletePlan: (plan_id) => {
      dispatch(deletePlan(plan_id));
    },
    resetDelete: () => {
      dispatch(deletePlanFailure());
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    resetCreate: () => {
      dispatch(createNewPlanFailure());
    },
  }
}

let DashboardPage = connect(mapStateToProps, mapDispatchToProps)(Dashboard)
export default DashboardPage;



// WEBPACK FOOTER //
// ./src/views/dashboard.js